import axios from 'axios';
import getParam from '../helpers/getParam';

const baseURL = process.env.REACT_APP_ORDO_FRONTEND_API;

const headers = {
  Authorization: `Basic ${window.btoa(
    `${process.env.REACT_APP_ORDO_USERNAME}:${process.env.REACT_APP_ORDO_API_KEY}`
  )}`
};

const getDashboardLink = async (orderNumber, setData) => {
  const token = getParam('token');
  const id = getParam('id');
  await axios
    .get(`${baseURL}/api/link/${orderNumber}`, {
      params: { id, token },
      headers
    })
    .then((response) => {
      const view = getParam('view');
      window.location.replace(`${response.data}${view ? `&view=${view}` : ''}`);
    })
    .catch((error) => {
      console.error({
        Message: 'Unable to fetch Dashboard Link.',
        Error: error.message,
        URL: error.config.url
      });
      setData(true);
    });
};

const getOrder = async (orderNumber, setData, setLoaded, cultureInfo) => {
  await axios
    .get(`${baseURL}/api/order/${orderNumber}`, {
      headers: {
        CultureInfo: cultureInfo,
        ...headers
      }
    })
    .then((response) => {
      setData(response.data);
      setLoaded(true);
    })
    .catch((error) => {
      setLoaded(true);

      console.error({
        Message: 'Unable to fetch Order Data.',
        Error: error.message,
        URL: error.config.url
      });
    });
};

const getMerchant = async (id, setData, setLoaded) => {
  await axios
    .get(`${baseURL}/api/Merchant/${id}`, { headers })
    .then((response) => {
      setData(response.data);
      setLoaded(true);
    })
    .catch((error) => {
      setData(null);
      setLoaded(true);

      console.error({
        Message: 'Unable to fetch Merchant Data.',
        Error: error.message,
        URL: error.config.url
      });
    });
};

export const ordoApiService = {
  GetDashboardLink: getDashboardLink,
  GetMerchant: getMerchant,
  GetOrder: getOrder
};
